import { render, staticRenderFns } from "./ComponentSidenavNotifications.vue?vue&type=template&id=6d6a57a8&"
import script from "./ComponentSidenavNotifications.vue?vue&type=script&lang=ts&"
export * from "./ComponentSidenavNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentSidenavNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports